import React from "react";
import PropTypes from "prop-types";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { I18n } from "aws-amplify/utils";

function ConfirmDeleteDialogMessage({ open, onClose, onConfirm, selectedIds }) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{I18n.get("Delete Confirmation")}</DialogTitle>
      <DialogContent>
        <DialogContentText>
        {I18n.get("Are you sure you want to delete these alarm type messages?")}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          {I18n.get("Cancel")}
        </Button>
        <Button
          onClick={() => onConfirm(selectedIds)} // Pass selected IDs when confirming
          color="primary"
          autoFocus
        >
          {I18n.get("Confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ConfirmDeleteDialogMessage.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  selectedIds: PropTypes.array.isRequired, // Pass selected row IDs
};

export default ConfirmDeleteDialogMessage;
